import React from 'react'
import { Box } from 'rebass'
import { MdPeople, MdToll } from 'react-icons/lib/md'
import { FaFileO, FaIndustry, FaListUl, FaFileText } from 'react-icons/lib/fa'
import styled from 'styled-components'

import Text from './Text'
import Link from './Link'

import routes from '../constants/routes'

const List = Box.extend`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
`

const StyledTile = Link.extend`
  height: 230px;
  width: 230px;
  padding: 1rem;
  margin: 0 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  text-decoration: none;
  color: ${props => props.theme.colors.text};
  text-align: center;
  border-radius: ${props => props.theme.borderRadius};
  
  &:hover {
    background-color: #ededed;
    text-decoration: none;
  }
  
  svg {
    height: 50px;
    width: 50px;
  }
`

const Align = Box.extend`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Docs = styled.div`
  margin: 3rem 0;
  text-align: center;
`

const Tile = ({to, Icon, title, text}) =>
  <StyledTile to={to}>
    <Align>
      <Icon />
      <Text h2 my={3}>{title}</Text>
      <Text is='span' light>{text}</Text>
    </Align>
  </StyledTile>

const Overview = () =>
  <div>
    <List py={3}>
      <Tile to={routes.USERS} Icon={MdPeople} title='Users' text='Manage users including their roles and addresses' />
      <Tile to={routes.BEACONS} Icon={MdToll} title='Devices' text='Add devices and assign to users' />
      <Tile to={routes.MANUFACTURERS} Icon={FaIndustry} title='Manufacturers' text='Add and manage device manufacturers' />
      <Tile to={routes.MODELS} Icon={FaListUl} title='Models' text='Add device models for a manufacturer' />
      <Tile to={routes.TEMPLATES} Icon={FaFileO} title='Templates' text='Add page templates and set pricing' />
      <Tile to={routes.PAGES} Icon={FaFileText} title='Pages' text='Add pages based on a template' />
    </List>
    <Docs>Please review the <Link blank href='https://docs.google.com/document/d/1y6m0Qtka5c-hg5AiF9kuy8vZKP96uXwfGG5Dn8Ay4_I/edit?usp=sharing'>console documentation</Link> to help guide usage and troubleshoot issues.</Docs>
  </div>

export default Overview


// WEBPACK FOOTER //
// ./src/components/Overview.js